var host = "https://api.fairdhaka.com/api";


const { h } = require("vue");

module.exports = {
    V1API: {
        'getAccessToken': host + '/authentication/token',
        'refreshAccessToken': host + '/authentication/token/refresh',
        'verifyLogin': host + '/authentication/token/verify',

        // Fair Dhaka
        'count_list': host + '/dashboard/count',
        'complain_list': host + '/dashboard/complaint/by-category/list/',
        'complain_delete': host + '/complaints/complaints/delete/',
        'get_wards': host + '/complaints/ward/list',
        'get_oncols': host + '/complaints/onchol/list',
        'update_status': host + '/dashboard/complaint/status-update',

        // Fair Dhaka Graph
        'complain_graph': host + '/dashboard/stats/complaint-trend',
        'complain_graph_by_category': host + '/dashboard/stats/resolution',
        'complain_graph_by_onchol': host + '/dashboard/stats/onchol-performance',
        'complain_graph_by_ward': host + '/dashboard/stats/ward-performance',

        // Project Doc
        // Upazila
        'upazila_list': host + '/location/upozila',
        'create_upazila': host + '/location/upozila/create',
        'update_upazila': host + '/location/upozila/edit/',
        'upazila_delete': host + '/location/upozila/delete/',

        // Union
        'union_list': host + '/location/union',
        'union_list_by_upazila': host + '/location/union/by-upozila/',
        'create_union': host + '/location/union/create',
        'update_union': host + '/location/union/edit/',
        'union_delete': host + '/location/union/delete/',

        // Shelter
        'shelter_list': host + '/location/shelter',
        'shelter_details': host + '/location/shelter/details/', 
        'create_shelter': host + '/location/shelter/create',
        'update_shelter': host + '/location/shelter/edit/',
        'shelter_delete': host + '/location/shelter/delete/',

        // Volunteer
        'volunteer_list': host + '/volunteer/accounts/list',
        'create_volunteer': host + '/volunteer/accounts/create',
        'update_volunteer': host + '/volunteer/accounts/edit/full/',
        'volunteer_delete': host + '/access-control/user-accounts/delete/',

        // House
        'house_list': host + '/home/list/admin-panel/full-list',
        'create_house': host + '/home/register',
        'other_member_delete': host + '/home/delete-listed/other-members',
        'other_member_edit': host + '/home/update-information/other-member/',
        'core_member_edit': host + '/home/update-information/core-member/',

        // Emergency Contact
        'count_list': host + '/dashboard/count',
        'contact_list': host + '/dashboard/complaint/by-category/list/',
        'create_contact': host + '/resource/contact/create',
        'update_contact': host + '/resource/contact/edit/',
        'contact_delete': host + '/resource/contact/delete/',

        // Relief
        'relief_list': host + '/resource/relief',
        'create_relief': host + '/resource/relief/create',
        'update_relief': host + '/resource/relief/edit/',
        'relief_delete': host + '/resource/relief/delete/',

        // Occupancy Summary
        'occupancy_summary_list': host + '/disaster-occupancy/all/sorted',

        //Portfolio
        // Blog
        'blog_list':host+'/blog/list',
        'create_blog':host+'/blog/create',
        'get_blog_details':host+'/blog/getdetail/slug',
        'update_blog':host+'/blog/update/',
        'blog_delete':host+'/blog/delete/',

        // Media Appearances
        'media_list':host+'/media_appearance/list',
        'create_media':host+'/media_appearance/create',
        'get_media_details':host+'/media_appearance/detail/slug',
        'update_media':host+'/media_appearance/update/',
        'media_delete':host+'/media_appearance/delete/',

        //Collaboration
        'collaboration_list':host+'/collaboration/list',
        'create_collaboration':host+'/collaboration/create',
        'get_collaboration_details':host+'/collaboration/getdetail/',
        'update_collaboration':host+'/collaboration/update/',
        'collaboration_delete':host+'/collaboration/delete/',

        // Gallery
        'gallery_list':host+'/gallery/list',
        'create_gallery':host+'/gallery/create',
        'get_gallery_details':host+'/gallery/detail/',
        'update_gallery':host+'/gallery/update/',
        'gallery_delete':host+'/gallery/delete/',

        //Publications
        'publication_list':host+'/publication/',
        'create_publication':host+'/publication/create',
        'get_publication_details':host+'/publication/detail/',
        'update_publication':host+'/publication/update/',
        'publication_delete':host+'/publication/delete/',
        'publication_category':host+'/publication/category/list',

        // Recents
        'recent_list':host+'/recent/list',
        'create_recent':host+'/recent/create',
        'get_recent_details':host+'/recent/getdetail/',
        'update_recent':host+'/recent/update/',
        'recent_delete':host+'/recent/delete/',

        //Dashboard
        'get_dashboard_count':host+'/dashboard/count',
        'get_demographic_count':host+'/dashboard/demographic/count',
        'get_dashboard_count_by_shelter':host+'/dashboard/count/by-shelter/',
        'get_demographic_count_by_shelter':host+'/dashboard/demographic/count/by-shelter/',
        'get_contact_list_by_shelter': host + '/resource/contact',
        'get_dashboard_count_by_shelter_live':host+'/disaster-occupancy/all',
        'get_demographic_count_by_shelter_live':host+'/disaster-occupancy/all-demographic',

    }
};
